module.exports = __webpack_public_path__ + "img/clla_logo_1.6d8aa651.png";